import z, { useRef as W, useCallback as T, useState as C, useEffect as F, useContext as G, useMemo as N } from "react";
import { a as q, b as V, c as D } from "./mergeProps-F8wVfzJL.mjs";
const w = (t) => {
  var n;
  return (n = t == null ? void 0 : t.ownerDocument) !== null && n !== void 0 ? n : document;
}, f = (t) => t && "window" in t && t.window === t ? t : w(t).defaultView || window;
function xe(t) {
  if (Y()) t.focus({
    preventScroll: !0
  });
  else {
    let n = J(t);
    t.focus(), Q(n);
  }
}
let g = null;
function Y() {
  if (g == null) {
    g = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return g = !0, !0;
        }
      });
    } catch {
    }
  }
  return g;
}
function J(t) {
  let n = t.parentNode, e = [], r = document.scrollingElement || document.documentElement;
  for (; n instanceof HTMLElement && n !== r; )
    (n.offsetHeight < n.scrollHeight || n.offsetWidth < n.scrollWidth) && e.push({
      element: n,
      scrollTop: n.scrollTop,
      scrollLeft: n.scrollLeft
    }), n = n.parentNode;
  return r instanceof HTMLElement && e.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), e;
}
function Q(t) {
  for (let { element: n, scrollTop: e, scrollLeft: r } of t)
    n.scrollTop = e, n.scrollLeft = r;
}
function L(t) {
  var n;
  return typeof window > "u" || window.navigator == null ? !1 : ((n = window.navigator.userAgentData) === null || n === void 0 ? void 0 : n.brands.some((e) => t.test(e.brand))) || t.test(window.navigator.userAgent);
}
function M(t) {
  var n;
  return typeof window < "u" && window.navigator != null ? t.test(((n = window.navigator.userAgentData) === null || n === void 0 ? void 0 : n.platform) || window.navigator.platform) : !1;
}
function A() {
  return M(/^Mac/i);
}
function X() {
  return M(/^iPhone/i);
}
function Z() {
  return M(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  A() && navigator.maxTouchPoints > 1;
}
function Fe() {
  return X() || Z();
}
function Me() {
  return L(/AppleWebKit/i) && !ee();
}
function ee() {
  return L(/Chrome/i);
}
function O() {
  return L(/Android/i);
}
function Pe() {
  return L(/Firefox/i);
}
function te(t) {
  return t.mozInputSource === 0 && t.isTrusted ? !0 : O() && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function ke(t) {
  return !O() && t.width === 0 && t.height === 0 || t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "mouse";
}
class ne {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(n, e) {
    this.nativeEvent = e, this.target = e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget, this.bubbles = e.bubbles, this.cancelable = e.cancelable, this.defaultPrevented = e.defaultPrevented, this.eventPhase = e.eventPhase, this.isTrusted = e.isTrusted, this.timeStamp = e.timeStamp, this.type = n;
  }
}
function re(t) {
  let n = W({
    isFocused: !1,
    observer: null
  });
  q(() => {
    const r = n.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let e = V((r) => {
    t == null || t(r);
  });
  return T((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      n.current.isFocused = !0;
      let o = r.target, a = (i) => {
        n.current.isFocused = !1, o.disabled && e(new ne("blur", i)), n.current.observer && (n.current.observer.disconnect(), n.current.observer = null);
      };
      o.addEventListener("focusout", a, {
        once: !0
      }), n.current.observer = new MutationObserver(() => {
        if (n.current.isFocused && o.disabled) {
          var i;
          (i = n.current.observer) === null || i === void 0 || i.disconnect();
          let l = o === document.activeElement ? null : document.activeElement;
          o.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: l
          })), o.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: l
          }));
        }
      }), n.current.observer.observe(o, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    e
  ]);
}
let u = null, p = /* @__PURE__ */ new Set(), v = /* @__PURE__ */ new Map(), d = !1, S = !1;
const oe = {
  Tab: !0,
  Escape: !0
};
function E(t, n) {
  for (let e of p) e(t, n);
}
function ae(t) {
  return !(t.metaKey || !A() && t.altKey || t.ctrlKey || t.key === "Control" || t.key === "Shift" || t.key === "Meta");
}
function h(t) {
  d = !0, ae(t) && (u = "keyboard", E("keyboard", t));
}
function c(t) {
  u = "pointer", (t.type === "mousedown" || t.type === "pointerdown") && (d = !0, E("pointer", t));
}
function K(t) {
  te(t) && (d = !0, u = "virtual");
}
function _(t) {
  t.target === window || t.target === document || (!d && !S && (u = "virtual", E("virtual", t)), d = !1, S = !1);
}
function B() {
  d = !1, S = !0;
}
function m(t) {
  if (typeof window > "u" || v.get(f(t))) return;
  const n = f(t), e = w(t);
  let r = n.HTMLElement.prototype.focus;
  n.HTMLElement.prototype.focus = function() {
    d = !0, r.apply(this, arguments);
  }, e.addEventListener("keydown", h, !0), e.addEventListener("keyup", h, !0), e.addEventListener("click", K, !0), n.addEventListener("focus", _, !0), n.addEventListener("blur", B, !1), typeof PointerEvent < "u" ? (e.addEventListener("pointerdown", c, !0), e.addEventListener("pointermove", c, !0), e.addEventListener("pointerup", c, !0)) : (e.addEventListener("mousedown", c, !0), e.addEventListener("mousemove", c, !0), e.addEventListener("mouseup", c, !0)), n.addEventListener("beforeunload", () => {
    R(t);
  }, {
    once: !0
  }), v.set(n, {
    focus: r
  });
}
const R = (t, n) => {
  const e = f(t), r = w(t);
  n && r.removeEventListener("DOMContentLoaded", n), v.has(e) && (e.HTMLElement.prototype.focus = v.get(e).focus, r.removeEventListener("keydown", h, !0), r.removeEventListener("keyup", h, !0), r.removeEventListener("click", K, !0), e.removeEventListener("focus", _, !0), e.removeEventListener("blur", B, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", c, !0), r.removeEventListener("pointermove", c, !0), r.removeEventListener("pointerup", c, !0)) : (r.removeEventListener("mousedown", c, !0), r.removeEventListener("mousemove", c, !0), r.removeEventListener("mouseup", c, !0)), v.delete(e));
};
function ie(t) {
  const n = w(t);
  let e;
  return n.readyState !== "loading" ? m(t) : (e = () => {
    m(t);
  }, n.addEventListener("DOMContentLoaded", e)), () => R(t, e);
}
typeof document < "u" && ie();
function ce() {
  return u !== "pointer";
}
function Ie() {
  return u;
}
function He(t) {
  u = t, E(t, null);
}
function We() {
  m();
  let [t, n] = C(u);
  return F(() => {
    let e = () => {
      n(u);
    };
    return p.add(e), () => {
      p.delete(e);
    };
  }, []), D() ? null : t;
}
const le = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function ue(t, n, e) {
  var r;
  const o = typeof window < "u" ? f(e == null ? void 0 : e.target).HTMLInputElement : HTMLInputElement, a = typeof window < "u" ? f(e == null ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement, i = typeof window < "u" ? f(e == null ? void 0 : e.target).HTMLElement : HTMLElement, l = typeof window < "u" ? f(e == null ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
  return t = t || (e == null ? void 0 : e.target) instanceof o && !le.has(e == null || (r = e.target) === null || r === void 0 ? void 0 : r.type) || (e == null ? void 0 : e.target) instanceof a || (e == null ? void 0 : e.target) instanceof i && (e == null ? void 0 : e.target.isContentEditable), !(t && n === "keyboard" && e instanceof l && !oe[e.key]);
}
function Ce(t, n, e) {
  m(), F(() => {
    let r = (o, a) => {
      ue(!!(e != null && e.isTextInput), o, a) && t(ce());
    };
    return p.add(r), () => {
      p.delete(r);
    };
  }, n);
}
function De(t) {
  let { isDisabled: n, onBlurWithin: e, onFocusWithin: r, onFocusWithinChange: o } = t, a = W({
    isFocusWithin: !1
  }), i = T((s) => {
    a.current.isFocusWithin && !s.currentTarget.contains(s.relatedTarget) && (a.current.isFocusWithin = !1, e && e(s), o && o(!1));
  }, [
    e,
    o,
    a
  ]), l = re(i), U = T((s) => {
    !a.current.isFocusWithin && document.activeElement === s.target && (r && r(s), o && o(!0), a.current.isFocusWithin = !0, l(s));
  }, [
    r,
    o,
    l
  ]);
  return n ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: U,
      onBlur: i
    }
  };
}
const se = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), fe = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function de(t) {
  if (Intl.Locale) {
    let e = new Intl.Locale(t).maximize(), r = typeof e.getTextInfo == "function" ? e.getTextInfo() : e.textInfo;
    if (r) return r.direction === "rtl";
    if (e.script) return se.has(e.script);
  }
  let n = t.split("-")[0];
  return fe.has(n);
}
const $e = Symbol.for("react-aria.i18n.locale");
function j() {
  let t = typeof window < "u" && window[$e] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      t
    ]);
  } catch {
    t = "en-US";
  }
  return {
    locale: t,
    direction: de(t) ? "rtl" : "ltr"
  };
}
let x = j(), b = /* @__PURE__ */ new Set();
function P() {
  x = j();
  for (let t of b) t(x);
}
function be() {
  let t = D(), [n, e] = C(x);
  return F(() => (b.size === 0 && window.addEventListener("languagechange", P), b.add(e), () => {
    b.delete(e), b.size === 0 && window.removeEventListener("languagechange", P);
  }), []), t ? {
    locale: "en-US",
    direction: "ltr"
  } : n;
}
const ve = /* @__PURE__ */ z.createContext(null);
function pe() {
  let t = be();
  return G(ve) || t;
}
const ge = Symbol.for("react-aria.i18n.locale"), he = Symbol.for("react-aria.i18n.strings");
let $;
class y {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(n, e) {
    let o = this.getStringsForLocale(e)[n];
    if (!o) throw new Error(`Could not find intl message ${n} in ${e} locale`);
    return o;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(n) {
    let e = this.strings[n];
    return e || (e = me(n, this.strings, this.defaultLocale), this.strings[n] = e), e;
  }
  static getGlobalDictionaryForPackage(n) {
    if (typeof window > "u") return null;
    let e = window[ge];
    if ($ === void 0) {
      let o = window[he];
      if (!o) return null;
      $ = {};
      for (let a in o) $[a] = new y({
        [e]: o[a]
      }, e);
    }
    let r = $ == null ? void 0 : $[n];
    if (!r) throw new Error(`Strings for package "${n}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return r;
  }
  constructor(n, e = "en-US") {
    this.strings = Object.fromEntries(Object.entries(n).filter(([, r]) => r)), this.defaultLocale = e;
  }
}
function me(t, n, e = "en-US") {
  if (n[t]) return n[t];
  let r = we(t);
  if (n[r]) return n[r];
  for (let o in n)
    if (o.startsWith(r + "-")) return n[o];
  return n[e];
}
function we(t) {
  return Intl.Locale ? new Intl.Locale(t).language : t.split("-")[0];
}
const k = /* @__PURE__ */ new Map(), I = /* @__PURE__ */ new Map();
class Le {
  /** Formats a localized string for the given key with the provided variables. */
  format(n, e) {
    let r = this.strings.getStringForLocale(n, this.locale);
    return typeof r == "function" ? r(e, this) : r;
  }
  plural(n, e, r = "cardinal") {
    let o = e["=" + n];
    if (o) return typeof o == "function" ? o() : o;
    let a = this.locale + ":" + r, i = k.get(a);
    i || (i = new Intl.PluralRules(this.locale, {
      type: r
    }), k.set(a, i));
    let l = i.select(n);
    return o = e[l] || e.other, typeof o == "function" ? o() : o;
  }
  number(n) {
    let e = I.get(this.locale);
    return e || (e = new Intl.NumberFormat(this.locale), I.set(this.locale, e)), e.format(n);
  }
  select(n, e) {
    let r = n[e] || n.other;
    return typeof r == "function" ? r() : r;
  }
  constructor(n, e) {
    this.locale = n, this.strings = e;
  }
}
const H = /* @__PURE__ */ new WeakMap();
function Ee(t) {
  let n = H.get(t);
  return n || (n = new y(t), H.set(t, n)), n;
}
function ye(t, n) {
  return n && y.getGlobalDictionaryForPackage(n) || Ee(t);
}
function Ae(t, n) {
  let { locale: e } = pe(), r = ye(t, n);
  return N(() => new Le(e, r), [
    e,
    r
  ]);
}
export {
  re as $,
  w as a,
  ce as b,
  Ce as c,
  De as d,
  Ae as e,
  Ie as f,
  xe as g,
  Pe as h,
  A as i,
  Me as j,
  Z as k,
  Fe as l,
  ke as m,
  te as n,
  f as o,
  pe as p,
  We as q,
  He as r,
  ye as s,
  y as t,
  Le as u
};
